import { z } from 'zod';
import { IsoDateTime } from './primitives.js';
import { OpaqueRef } from './ids.js';
/**
 * A bookable interval, **half-open `[start, end)`** (agreement section 4.2,
 * rule 3). Half-open is not a detail: it is why a 13:00–14:00 booking and a
 * 14:00–15:00 booking do not collide, and it is what the Postgres `tstzrange`
 * on `appointments` stores.
 */
export const Slot = z.object({
    start: IsoDateTime,
    end: IsoDateTime,
    resource_id: OpaqueRef,
});
/** A slot as offered to a caller: which service it is for, and how many fit. */
export const OfferedSlot = Slot.extend({
    service_id: OpaqueRef,
    capacity: z.number().int().min(1),
});
/** `live` only when this system holds the book for the tenant (spec 4.4). */
export const Authority = z.enum(['live', 'approximate']);
/**
 * `slots` is what matches the ask. `alternatives` is what to offer when it does
 * not — and it is populated whenever the ask does not fit, never left empty
 * because the answer was "no". The agreement calls this out as mattering more
 * than the rest of the document (section 4.2, rule 1).
 */
export const AvailabilityResult = z.object({
    authority: Authority,
    slots: z.array(OfferedSlot),
    alternatives: z.array(OfferedSlot),
    summary: z.string(),
});
export const AvailabilityQuery = z.object({
    service_id: OpaqueRef.optional(),
    date_from: z.string(),
    date_to: z.string(),
    party_size: z.number().int().min(1).max(50).default(1),
    timezone: z.string().optional(),
    limit: z.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=slot.js.map